import api from '../index'

export default {

    /**
     * Show a credit note
     * @param billingAccount
     * @param creditNote ID
     * @param params
     */
    show(billingAccount, creditNote, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/credit-notes/${creditNote}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Download credit note as PDF
     * @param billingAccount
     * @param creditNote ID
     * @param params
     */
    download(billingAccount, creditNote, params) {
        return api
            .get(`/billing/billing-accounts/${billingAccount}/credit-notes/${creditNote}/download`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    }

}
